import React, { useContext, createContext } from "react";

export type RouteDef = {
  name: string;
  path: string;
  component: React.ComponentType<unknown>;
  layout?: React.ComponentType<unknown>;
};

export type RouteMap = Record<string, RouteDef>;

export const RoutesContext = createContext<RouteMap>({});

export function useRoutes() {
  return useContext(RoutesContext);
}
